import { List, Map } from "immutable";

import { TAG_TYPES } from "@seneca/tags-service-consts";

import tagsActionTypes, { ActionTypes } from "../../../action-types";
import Category from "../../../models/Category";

type CategoriesState = Map<string, Category>;

export function makeReducer(actionTypes: ActionTypes) {
  function categoryReducer(
    state: CategoriesState = Map<string, Category>(),
    action: any
  ) {
    if (action.type === actionTypes.RECEIVE_TAGS_AND_CATEGORIES) {
      const categories = action.payload.tags.filter(
        (category: any) => category.type === TAG_TYPES.category
      );
      const newState = Map();
      return newState.withMutations(newState => {
        return categories.reduce((acc: any, category: any) => {
          const { id, tagIds, details, ...restOfCategory } = category;
          return acc.set(
            id,
            new Category({
              id,
              ...restOfCategory,
              tagIds: List(tagIds),
              details: Map(details)
            })
          );
        }, newState);
      });
    }

    return state;
  }

  return categoryReducer;
}

export default makeReducer(tagsActionTypes);
